import { adjust, assoc, compose, map, pick, prop, propOr } from 'ramda';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import { useState } from 'react';
import useSaveSimulationProductMutation from './useSaveSimulationProductMutation.js';
import extraProcessSaveProductInput from '../extra/extraProcessSaveProductInput.mjs';
import useDownloadProductNoticeMutation from './useDownloadProductNoticeMutationQuery.js';

const useSimulationProductForm = ({
  getSimulationProduct,
  setShowNoticeError
}) => {
  const isLocal = process.env.NODE_ENV === 'development';
  const [loading, setLoading] = useState(false);
  const saveProduct = useSaveSimulationProductMutation();
  const { processHandlers, context } = useProcess();
  const { onFormSubmit: downloadProductNotice } = useDownloadProductNoticeMutation();

  const products = propOr([], 'products', getSimulationProduct);

  const updateSelectedProduct = (index) => {
    const selectedProducts = compose(
      adjust(index, assoc('isSelected', true)),
      map(assoc('isSelected', false))
    )(products);
    $onNextClick(selectedProducts);
  };

  const handleLoadNotices = (code) => {
    setShowNoticeError(false);
    downloadProductNotice({ productCode: code }, (ok, error, { url }) => {
      if (ok && !error) {
        window.open(url);
      } else {
        setShowNoticeError(true);
      }
    });
  };

  const $onNextClick = (selectedProducts) => {
    if (loading) return;
    setLoading(true);
    let input = map(
      pick([
        'code',
        'name',
        'isSelected',
        'viewMode',
        'status',
        'customOutput1',
        'customOutput2',
        'customOutput3',
        'customOutput4',
        'customOutput5'
      ]),
      selectedProducts
    );
    input = extraProcessSaveProductInput(input);
    saveProduct.onFormSubmit({ products: input }, (ok, error) => {
      if (ok && !error) {
        processHandlers.onNext({ context: { projectId: context?.projectId } });
      } else {
        setLoading(false);
      }
    });
  };

  const $onPrevClick = () => {
    processHandlers.onPrev({
      context: {
        projectId: context?.projectId
      }
    });
  };

  const getProductImage = (product) => {
    const basePath = isLocal ? '/public/tmp/images/' : '/images/';
    return prop('code', product) && `${basePath}${prop('code', product)}.jpg`;
  };

  return {
    products,
    updateSelectedProduct,
    $onNextClick,
    $onPrevClick,
    handleLoadNotices,
    getProductImage
  };
};

export default useSimulationProductForm;
